import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import banner1 from '../../assets/banners/banner-1.jpg';
import banner2 from '../../assets/banners/banner-2.jpg';
import banner3 from '../../assets/banners/banner-3.jpg';
import banner4 from '../../assets/banners/mobile-banner (1).png';
import banner5 from '../../assets/banners/mobile-banner (2).png';
import banner6 from '../../assets/banners/mobile-banner (3).png';
import { Link } from 'react-router-dom';
import creative from '../../assets/hero/creativity.png'
import start from '../../assets/hero/sparkling.png';
import 'swiper/css';
import 'swiper/css/navigation';
import herovideo from '../../assets/hero/herovideo.mp4';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const Hero = () => {

  // ✅ Add this state to delay video loading
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVideoLoaded(true), 800); // load after page is stable
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Desktop Hero Section */}
      {/* <div className="container-fluid p-0 desktopSection">           
        <section className="hero" style={{ position: "relative", height: "100vh", overflow: "hidden" }}>          
          
          {videoLoaded && (
            <video
              src={herovideo}
              autoPlay
              muted
              loop
              playsInline
              preload="none"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
              }}
            />
          )}

          <div style={{
            width:"100%",
            height:"100%",
            backgroundColor:'rgba(63, 63, 63, 0.5)',
            position:"absolute"
            }}></div>
        </section>

        <div className="slider-wrapper">
          <div className="slider-text">
            Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
          </div>
          <div className="slider-text">
            Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
          </div>
        </div>
      </div> */}

      <div className='container-fluid desktopSection p-0'>          
        <div className="container-fluid p-0">
            <div className='bg-header'>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-12 d-flex justify-content-'>
                      {/* <h1>Code <span className='text-warning'>.</span> Create <span className='text-danger'>.</span> Captivate 0</h1>  */}
                      <h1>Code <span className='text-warning jump'>.</span> Create <span className='text-danger jump'>.</span> Captivate <span className='text-primary jump'>.</span></h1> 
                  </div>
                </div>
              </div> 
            </div>          
        </div>
        
        <div className="slider-wrapper mt-5">
            <div className="slider-text">
              Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
            </div>
            <div className="slider-text">
              Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
            </div>
        </div>

      </div>
      {/* Mobile View */}
      <div className="container-fluid p-0 mobileSection">
        <div className='container mobilehero p-0' style={{height:'100vh', background: "linear-gradient(to right, #3e13c0 ,  #426fec)", overflow:'hidden'}}>
          <div className="row g-2">
            <div className="col-md-6">
              <img src={banner1} alt='application development' style={{height:'50vh', width:'100%', objectFit:'cover'}}/>
            </div>
            <div className="col-md-6 p-2">
              <h2>BEST APPLICATION DEVELOPMENT COMPANY IN DELHI, NCR</h2>
              <Link to="/contact" className='btn btn-light mt-2 d-flex justify-content-center align-items-center'
                style={{
                  position: 'absolute',
                  zIndex: 10,
                  border: 'none',
                  width:'200px',
                  height:'50px',
                  background: 'linear-gradient(to right, #3e13c0 ,  #f4f5f7)',
                  color:'#0b0b0b',
                  fontWeight:'600',
                }}>
                Talk To Expert
              </Link>
            </div>
          </div>
        </div>

        <div className="slider-wrapper">
          <div className="slider-text">
            Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
          </div>
          <div className="slider-text">
            Your Dream Our Digital Canvas Your Dream Our Digital Canvas Your Dream Our Digital Canvas
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
